import {envIsCloudOnprem, envIsLocal} from '@wandb/common/config';
import React, {FC, memo} from 'react';

import {OrgType} from '../generated/graphql';
import {useViewer} from '../state/viewer/hooks';
import {navigateTo} from '../util/history';
import {CreateTeamButton} from './CreateTeamModal';
import * as S from './InviteTeamButton.styles';
import InviteTeamButtonLocal from './InviteTeamButtonLocal';

const InviteTeamButtonComp: FC = () => {
  const viewer = useViewer();

  if (envIsLocal) {
    return <InviteTeamButtonLocal />;
  }

  if (viewer == null) {
    return <></>;
  }

  const hasNonPersonalOrgs = viewer.organizations.some(
    o => o.orgType !== OrgType.Personal
  );

  if (hasNonPersonalOrgs) {
    return <></>;
  }

  if (envIsCloudOnprem) {
    // In onprem, we don't use /create-team.
    return (
      <CreateTeamButton
        onCreate={() => window.location.reload()}
        renderButton={onClick => (
          <S.Container>
            <S.Button
              onClick={() => {
                onClick();
                window.analytics?.track('Create Team Started', {
                  location: 'search nav',
                });
              }}>
              Create Team
            </S.Button>
          </S.Container>
        )}
      />
    );
  }

  return (
    <S.Container>
      <S.Button
        onClick={() => {
          navigateTo({pathname: '/create-team'});
          window.analytics?.track('Create Team Started', {
            location: 'search nav',
          });
        }}>
        Create Team
      </S.Button>
    </S.Container>
  );
};

export const InviteTeamButton = memo(InviteTeamButtonComp);
